namespace Areas {
    "use strict";

    const columnChooserButtonName = "columnChooserButton";

    export function addColumnChooser(e: any) {
        const grid: DevExpress.ui.dxDataGrid = e.component;
        ignoreColumnOptionNames(grid);
        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { id: columnChooserButtonName, "class": "dx-datagrid-column-chooser-button" },
            text: "Columns",
            hint: "Choose columns to show/hide",
            type: "normal",
            icon: "column-chooser",
            onClick: showColumnChooser(grid)
        }, "after");

    }

    export function customStateStore(e: any) {
        // The selected rows are removed from the state before storing it and
        // if the stored state has selected rows they are removed before
        // restoring grid state.

        const grid: DevExpress.ui.dxDataGrid = e.component;
        const stateStoring = grid.option("stateStoring");
        const gridName = grid.option("gridName");

        stateStoring.type = "custom";

        stateStoring.customLoad = () => {
            let state = JSON.parse(localStorage.getItem(stateStoring.storageKey));
            if (state != null) {
                    state.selectedRowKeys = [];
            }
            return state;
        };

        stateStoring.customSave = (state) => {
            state.selectedRowKeys = [];
            localStorage.setItem(stateStoring.storageKey, JSON.stringify(state));
        };
    }

    function ignoreColumnOptionNames(grid: DevExpress.ui.dxDataGrid) {
        // This is necessary since we are not setting columnChoose: { enabled: True }
        // for the grid to show the column chooser button but we are taking over that
        // functionality, otherwise state storing will not work properly with the column visibility property.
        grid.option("stateStoring.ignoreColumnOptionNames", []);
    }

    function showColumnChooser(grid: DevExpress.ui.dxDataGrid) {
        return (e: any) => {
            grid.showColumnChooser();
        }
    }

}
